/**
 * @description 路由拦截状态管理，目前两种模式：all模式与intelligence模式，其中partialRoutes是菜单暂未使用
 */
import { asyncRoutes, constantRoutes, resetRouter, appRoutes } from '@/router'
import { getRouterList } from '@/api/router'
import { convertRouter, filterRoutes } from '@/utils/routes'
import { authentication, rolesControl } from '@/config'
import { isArray } from '@/utils/validate'
import { gp } from '@vab'

const state = () => ({
  routes: [],
  cachedRoutes: [],
  //appRoutes 功能路由
  appRoutes: [],
  //动态路由
  dynamicRoutes: [],
  //初始化的路由
  initRoutes:[]
})
const getters = {
  routes: (state) => state.routes,
  cachedRoutes: (state) => state.cachedRoutes,
  appRoutes: (state) => state.appRoutes,
  dynamicRoutes: (state) => state.dynamicRoutes,
  initRoutes:(state)=>state.initRoutes
}
const mutations = {
  /**
   * @description 多模式设置路由
   * @param {*} state
   * @param {*} routes
   */
  setRoutes(state, routes) {
    state.routes = routes
  },
  /**
   * @description 设置缓存Name数组
   * @param {*} state
   * @param {*} routes
   */
  setCachedRoutes(state, routes) {
    state.cachedRoutes = routes
  },
  /**
   * @description 设置appRoutes
   * @param {*} state
   * @param {*} routes
   */
  setAppRoutes(state, routes) {
    state.appRoutes = routes
  },
  setDynamicRoutes(state, routes) {
    state.dynamicRoutes = routes
  },
  setInitRoutes(state, routes) {
    state.initRoutes = routes
  },
  /**
   * @description 修改Meta
   * @param {*} state
   * @param options
   */
  changeMenuMeta(state, options) {
    function handleRoutes(routes) {
      return routes.map((route) => {
        if (route.name === options.name) Object.assign(route.meta, options.meta)
        if (route.children && route.children.length)
          route.children = handleRoutes(route.children)
        return route
      })
    }

    state.routes = handleRoutes(state.routes)
  },
}
const actions = {
  /**
   * @description 多模式设置路由
   * @param {*} { commit }
   * @param mode
   * @returns
   */
  async setRoutes({ commit }, mode = 'none') {
    // 默认前端路由
    let routes = [...asyncRoutes]
    //需要动态显示的路由
    let dynamicRoutes = [...appRoutes]
    // 设置游客路由关闭路由拦截(不需要可以删除)
    const control = mode === 'visit' ? false : rolesControl
    // 设置后端路由(不需要可以删除)
    if (authentication === 'all') {
      const { data } = await getRouterList()
      const { list } = data
      if (!isArray(list))
        gp.$baseMessage(
          '路由格式返回有误！',
          'error',
          false,
          'vab-hey-message-error'
        )
      if (list[list.length - 1].path !== '*')
        list.push({
          path: '/:pathMatch(.*)*',
          redirect: '/404',
          name: 'NotFound',
          hidden: true,
        })
      routes = convertRouter(list)
    }
    // 根据权限和rolesControl过滤路由
    const finallyRoutes = filterRoutes([...constantRoutes, ...routes], control)
    //根据权限和rolesControl过滤动态路由路由
    const finallyDynamicRoutes = filterRoutes([...dynamicRoutes], control)
    // 设置菜单所需路由
    commit('setRoutes', finallyRoutes)
    commit('setInitRoutes', finallyRoutes)
    commit('setAppRoutes', finallyDynamicRoutes)
    commit('setDynamicRoutes', [])
    console.log('finallyRoutes ---------', finallyRoutes)
    console.log('finallyDynamicRoutes ---------', finallyDynamicRoutes)
    // 根据可访问路由重置Vue Router
    await resetRouter(finallyRoutes)
  },
  /**
   * @description 设置缓存Name数组
   * @param {*} { commit }
   * @param {*} routes
   */
  setCachedRoutes({ commit }, routes) {
    commit('setCachedRoutes', routes)
  },
  setAppRoutes({ commit }, routes) {
    commit('setAppRoutes', routes)
  },
  setDynamicRoutes({ commit }, routes) {
    commit('setDynamicRoutes', routes)
  },
  setInitRoutes({ commit }, routes) {
    commit('setInitRoutes', routes)
  },
  /**
   * @description 修改Route Meta
   * @param {*} { commit }
   * @param options
   */
  changeMenuMeta({ commit }, options = {}) {
    commit('changeMenuMeta', options)
  },
}
export default { state, getters, mutations, actions }
